import React from 'react';
import AddItem from './_AddItem.jsx';

export default class MyCollectionHeader extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isExpanded: false
            , keyword: this.props.data.strSearchKeyword
        }
    }

    updateKeyword(e) {
        this.setState({ keyword: e.target.value });
    }

    expandSearch() {
        if (!this.state.isExpanded) {
            const elementsTitle = document.getElementsByClassName("personal-inventory__header-title-section");
            elementsTitle[0].classList.toggle('personal-inventory__hide');
            const elementsSearch = document.getElementsByClassName("personal-inventory__header-search-mobile-view");
            elementsSearch[0].classList.toggle('personal-inventory__expand-full-width');
            this.setState({ isExpanded: true });
        }
        else {
            this.doSearch();
        }
    }
    downscaleSearch() {
        const elementsTitle = document.getElementsByClassName("personal-inventory__header-title-section");
        elementsTitle[0].classList.toggle('personal-inventory__hide');
        const elementsSearch = document.getElementsByClassName("personal-inventory__header-search-mobile-view");
        elementsSearch[0].classList.toggle('personal-inventory__expand-full-width');
        this.setState({ isExpanded: false });
    }

    clearKeyword() {
        this.setState({keyword: ""});
        this.props.func.doSearch("");
    }

    doSearch() {
        if (this.state.keyword != this.props.data.strSearchKeyword) this.props.func.doSearch(this.state.keyword);
    }

    render() {
        const keyword = this.state.keyword;
        return (
            <section className=" personal-inventory__header l-margin-bottom--xl">
                <div className="personal-inventory__edge-to-edge-header l-margin-x--auto">
                    <div className="personal-inventory__hide-mobile personal-inventory__grid-cols l-pad-x">
                        <div className="personal-inventory__header-title-cols personal-inventory__header-title ">
                            <div id="MPI-header-text">
                                MY COLLECTION
                            </div>
                        </div>
                        <div className="personal-inventory__header-search-cols l-margin-y--auto">
                            <div className="personal-inventory__header-search l-flex ">
                                <button className="personal-inventory__btn-search l-cursor-pointer" onClick={() => this.doSearch()}><i className="far fa-search" /></button>
                                <input
                                    type="text"
                                    className="text-input text--small l-full-width l-border--null personal-inventory__search-all-inp"
                                    placeholder="Search My Collection"
                                    onChange={(e) => this.updateKeyword(e)}
                                    onKeyUp={(e) => {(e.keyCode == 13) ? this.doSearch() : null}}
                                    value={keyword}
                                />
                                {(keyword.length > 0)&&<button className="l-pad-x--sm" onClick={() => this.clearKeyword()}><i className="fa-solid fa-circle-xmark" /></button>}
                            </div>
                        </div>
                    </div>
                    <div className="personal-inventory__show-only-mobile personal-inventory__grid-cols-header-mobile l-full-height">
                        <div className="l-flex l-split personal-inventory__header-pad l-full-height l-pad-x">
                            <div id="id-header-title-mobile" className="personal-inventory__header-title">
                                <div id="MPI-header-text" className="personal-inventory__header-title-section">
                                    MY COLLECTION
                                </div>
                            </div>
                            <div className="personal-inventory__header-search-mobile-view l-margin-y--auto">
                                <div className="personal-inventory__show-only-mobile l-flex">
                                    <button className="personal-inventory__btn-search l-cursor-pointer l-margin-y--auto" onClick={() => this.expandSearch()}><i className="far fa-search" /></button>
                                    <input
                                        type="text"
                                        className="text-input text--small l-full-width l-border--null personal-inventory__search-all-inp"
                                        placeholder="Search My Collection"
                                        onChange={(e) => this.updateKeyword(e)}
                                        onKeyUp={(e) => {(e.keyCode == 13) ? this.doSearch() : null}}
                                        value={keyword}
                                    />
                                    {(keyword.length > 0)&&<button className="l-pad-x--sm" onClick={() => this.clearKeyword()}><i className="fa-solid fa-circle-xmark" /></button>}
                                </div>
                            </div>


                        </div>
                    </div>
                </div>

            </section>
        )

    }

}